




















import {useGetters} from "vuex-composition-helpers"
import {defineComponent} from "@vue/composition-api"
import InnerLoader from "@/shared/components/atoms/InnerLoader.vue"

export default defineComponent({
    name: "ModalComponent",
    components: {InnerLoader},
    setup: () => {
        const {innerLoading, config} = useGetters(['innerLoading', 'config']);

        return {
            innerLoading, config
        }
    }
})
